import keyboard from "js/constants/keyboard"
import map from "rfuncs/functions/map"
import object_map from "rfuncs/functions/object_map"
import set_property from "workflow/vue/3/set_property"
import virtual from "workflow/vue/3/virtual"

const key_state = virtual({
    data: () => map(() => false, keyboard)
})
const reverse_keyboard = object_map(
    v => v,
    (v, k) => k,
    keyboard
)
const set_to = value => e => {
    const prop = reverse_keyboard[e.keyCode]

    if (prop) set_property(key_state, prop, value)
}

export default key_state

window.addEventListener("keydown", set_to(true))
window.addEventListener("keyup", set_to(false))
